var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { align: "end" } },
        [
          _c("v-col", { attrs: { cols: "12" } }, [
            _c("h2", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "delegation.delegationNewBasedOnDelegationOrder.title"
                    )
                  ) +
                  " "
              )
            ])
          ]),
          _c("v-col", { attrs: { cols: "6" } }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "delegation.delegationNewBasedOnDelegationOrder.chooseBaseDelegationOrder"
                )
              )
            ),
            _c("br"),
            _vm.isDelegationOrderRequired
              ? _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "delegation.delegationNewBasedOnDelegationOrder.delegationOrderRequired"
                      )
                    )
                  )
                ])
              : _vm._e()
          ]),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer")
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          staticClass: "elevation-1",
          attrs: {
            headers: _vm.headers,
            items: _vm.delegationOrders,
            search: _vm.search
          },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function(props) {
                return [
                  _c("tr", [
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            !!props.item.number
                              ? props.item.number
                              : _vm.$t("components.documentNumber.notSet")
                          ) +
                          " "
                      )
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            !!props.item.delegated_user
                              ? props.item.delegated_user
                              : _vm.$t("global.notSet")
                          ) +
                          " "
                      )
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            !!props.item.date_start
                              ? props.item.date_start
                              : _vm.$t("global.notSet")
                          ) +
                          " "
                      )
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            !!props.item.date_end
                              ? props.item.date_end
                              : _vm.$t("global.notSet")
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "td",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: { text: "", icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.previewDelegationOrder(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_c("v-icon", [_vm._v("search")])],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "delegation.delegationNewBasedOnDelegationOrder.previewDelegationOrderDetails"
                                  )
                                )
                              )
                            ])
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              text: "",
                                              icon: "",
                                              disabled: !(
                                                props.item.delegationId ==
                                                  null &&
                                                props.item.status === 3
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.chooseDelegationOrder(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_c("v-icon", [_vm._v("send")])],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            props.item.delegationId == null &&
                            props.item.status === 3
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("global.choose")))
                                ])
                              : props.item.status !== 3
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "delegation.delegationNewBasedOnDelegationOrder.onlyAcceptedOrders"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "delegation.delegationNewBasedOnDelegationOrder.alreadyCreatedSettlement"
                                      )
                                    )
                                  )
                                ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              }
            }
          ])
        },
        [
          _c(
            "template",
            { slot: "no-data" },
            [
              _c("v-alert", { attrs: { color: "error", icon: "warning" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "delegation.delegationNewBasedOnDelegationOrder.noData"
                      )
                    ) +
                    " "
                )
              ])
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }